import { render, staticRenderFns } from "./FormRequest.vue?vue&type=template&id=e8e48da2&"
import script from "./FormRequest.vue?vue&type=script&lang=js&"
export * from "./FormRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports